import { normalizeCxpRedirectPath } from "../utilities/URLUtils";

// src/security/PublicSecureSSO.ts
// This file handles SSO login by redirecting to cxp-ui's login page.
// The original signin function is now obsolete.

export async function signinSSO(appId: string, isEng: boolean) {
  // Public Secure section should not participate in workflow after button-triggered sign-in.
  localStorage.removeItem("trackPublicSecureAfterSignin");
  localStorage.removeItem("authReturnSource");

  // Set flag in localStorage to advance past public secure section after returning from CXP
  // localStorage persists across domain navigations unlike sessionStorage
  // Store with timestamp for expiration (5 minutes)
  const flagData = {
    value: true,
    timestamp: Date.now(),
    expiresIn: 5 * 60 * 1000, // 5 minutes
  };
  console.log("[signinSSO] Setting advanceAfterCxpReturn flag:", flagData);
  localStorage.setItem("advanceAfterCxpReturn", JSON.stringify(flagData));
  console.log(
    "[signinSSO] Flag set, verification:",
    localStorage.getItem("advanceAfterCxpReturn"),
  );

  // Get the current path (relative, not full URL)
  const currentPath = normalizeCxpRedirectPath(
    window.location.pathname + window.location.search + window.location.hash,
  );
  // Persist previousUrl so post-auth tracking can use the last visible pre-auth page
  // (e.g., instructions) rather than intermediate skipped sections.
  localStorage.setItem(
    "previousUrlBeforeOAuth",
    sessionStorage.getItem("previousUrl") || window.location.href,
  );
  console.log(
    "[signinSSO] Redirecting to CXP signin, will return to:",
    currentPath,
  );
  // Redirect to cxp-ui's login with correct path and return to form-ui after login
  const cxpSignInUrl = `/web/auth/signin?redirectUri=${encodeURIComponent(currentPath)}`;
  window.location.href = cxpSignInUrl;
}

// Note: Remove or mark the original signin function in PublicSecure.ts as obsolete.
